/* eslint-disable */

var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

// Les fontaines sont gérées dans l'admin WordPress (menu « Fontaines »)
// et exposées par l'endpoint REST défini dans app/fontaines.php.
const container = document.querySelector('#map-fontaine')

if (container && window.fontainesConfig) {
  const { endpoint, token } = window.fontainesConfig

  mapboxgl.accessToken = token

  const mapEau = new mapboxgl.Map({
    container: 'map-fontaine',
    center: [6.166667, 49.133333],
    zoom: 11,
    maxZoom: 15,
    minZoom: 8,
    style: 'mapbox://styles/mapbox/streets-v11',
  })

  const buildPopup = (fontaine) => {
    const wrapper = document.createElement('div')

    const name = document.createElement('div')
    name.className = 'popup_name'
    name.textContent = fontaine.name

    const address = document.createElement('p')
    address.className = 'popup_address'
    address.textContent = fontaine.address

    wrapper.appendChild(name)
    wrapper.appendChild(address)

    return new mapboxgl.Popup({ offset: 25 }).setDOMContent(wrapper)
  }

  fetch(endpoint)
    .then((response) => response.json())
    .then((fontaines) => {
      const bounds = new mapboxgl.LngLatBounds()

      fontaines.forEach((fontaine) => {
        new mapboxgl.Marker()
          .setLngLat([fontaine.lng, fontaine.lat])
          .setPopup(buildPopup(fontaine))
          .addTo(mapEau)
        bounds.extend([fontaine.lng, fontaine.lat])
      })

      // Cadre la carte pour afficher tous les points d'un coup
      if (!bounds.isEmpty()) {
        mapEau.fitBounds(bounds, { padding: 50, maxZoom: 15, duration: 0 })
      }
    })
}



// WEBPACK FOOTER //
// ./scripts/map-fontaine.js